import { type UseQueryResult, useQuery } from 'react-query';
import {
  BlackoutService,
  PagedResultDto_BlackoutListDTO,
  // eslint-disable-next-line camelcase
} from '@wealthlane/api-services/wealthlane-customer-service';
import { type TableParamsType } from '../../types/common';

const useGetTradingBlackoutConfigList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  | PagedResultDto_BlackoutListDTO
  | undefined,
  unknown
> => {
  const { eligibleIds, fromDate, toDate, filter, sorting, skipCount, maxResultCount } = tableInfo;
  const tradingBlackoutConfig = useQuery(
    [
      'getTradingBlackoutConfigList',
      eligibleIds,
      fromDate,
      toDate,
      filter,
      sorting,
      skipCount,
      maxResultCount,
    ],
    async () => {
      const tradingBlackoutConfigList = await handleRequest(
        BlackoutService.getApiCustomerApiAppBlackoutBlackoutList(
          eligibleIds,
          fromDate,
          toDate,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );

      return tradingBlackoutConfigList;
    }
  );
  return tradingBlackoutConfig;
};

export default useGetTradingBlackoutConfigList;
